// Builds a Mapbox Static Images API URL for a single hotel location. Used to render a lightweight,
// non-interactive map preview (e.g. inside the hotel details modal) that opens the full interactive
// map on click. The style id and public access tokens are shared with the interactive map (see
// SearchPageContainer/MapContainer/types) so the preview matches the live map's basemap.
import {
  MAPBOX_ACCESS_TOKEN,
  MAPBOX_ACCESS_TOKEN_WHITELABEL,
  MAPBOX_STYLE_ID,
} from '@/app/components/search/components/SearchPageContainer/MapContainer/types';

type StaticMapOptions = {
  coordinates: LatLng;
  /** Logical width in px (Mapbox caps each side at 1280; @2x doubles the rendered pixels). */
  width: number;
  /** Logical height in px. */
  height: number;
  /** Higher = more zoomed in. Defaults to 15 to match the interactive map's initial hotel zoom. */
  zoom?: number;
  isWhiteLabel?: boolean;
};

export function buildHotelStaticMapUrl({
  coordinates,
  width,
  height,
  zoom = 15,
  isWhiteLabel = false,
}: StaticMapOptions): string {
  const { latitude, longitude } = coordinates;
  const token = isWhiteLabel ? MAPBOX_ACCESS_TOKEN_WHITELABEL : MAPBOX_ACCESS_TOKEN;

  // No overlay marker: the hotel sits dead-centre of the returned image, and the caller draws its
  // own branded marker (pink pill + bed icon) over that centre point.
  // logo=false + attribution=false strip the baked-in Mapbox wordmark and credit — which can't be
  // styled and get cropped by object-fit. The caller renders its own styled DOM attribution instead
  // (mirroring the interactive map's AttributionControl), satisfying Mapbox's attribution rule.
  return `https://api.mapbox.com/styles/v1/${MAPBOX_STYLE_ID}/static/${longitude},${latitude},${zoom}/${width}x${height}@2x?logo=false&attribution=false&access_token=${token}`;
}
